import Collapsible from "app/components/Collapsible/Collapsible";
import IconTrash from "app/components/Icon/components/IconTrash/IconTrash";
import { IconSports } from "app/components/Icon/Icon";
import { BetSlipHelper } from "app/helpers/betSlipHelper";
import { TranslationHelper } from "app/helpers/translationHelper";
import { BetSlipType } from "app/types/betSlipType";
import { MultiplesBetSlipType } from "app/types/multiplesBetSlipType";
import { MarketPeriods, MarketTypes, REGEX_VS } from "app/utils/const";
import cx from "classnames";
import words from "lodash/words";
import { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import "./MultiplesBetSlip.scss";

type Props = {
  history: any;
  multiplesBetSlipList: MultiplesBetSlipType[];
  intl: any;
  removeMultipleLeg: Function;
  validateMultiples: Function;
  betSlipList: BetSlipType[];
  removeBetSlip: Function;
};

type State = {
  isActive: boolean;
};

class MultiplesBetSlip extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      isActive: true,
    };
  }
  renderTeamName = (teamName: string) => {
    return (
      <div className="multiples-bet-slip__header__team-name">
        <span>{teamName}</span>
      </div>
    );
  };
  renderFormattedHandicap(multiplesBetSlip) {
    if (
      multiplesBetSlip.runner &&
      multiplesBetSlip.runner.modalFormattedHandicap
    ) {
      return multiplesBetSlip.runner.modalFormattedHandicap;
    } else if (
      multiplesBetSlip.runner &&
      multiplesBetSlip.runner.formattedHandicap
    ) {
      return multiplesBetSlip.runner.formattedHandicap;
    } else {
      return "";
    }
  }
  toggleCollapsible = () => {
    this.setState({
      isActive: !this.state.isActive,
    });
  };
  removeMultipleBetSlip = (runnerId: number) => {
    this.props.removeMultipleLeg(runnerId);
    this.removeCorrespondingSingleBet(runnerId);
    this.props.validateMultiples();
  };
  // if multiple bet remove from multiple betslip panel
  // remove corresponding single bet from single betslip panel
  removeCorrespondingSingleBet = (runnerId: number) => {
    const { betSlipList, removeBetSlip } = this.props;
    // get localID for corresponding single bet being removed
    const correspondingBetSlip = betSlipList.find(
      (betSlip: BetSlipType) => betSlip.markets[0].runners[0].id === runnerId
    );
    // remove single bet from betslip panel
    removeBetSlip(correspondingBetSlip && correspondingBetSlip.localId);
  };

  getBetSlipContent = () => {
    const { multiplesBetSlipList, intl } = this.props;
    // Get the " vs " or " at " from the event name
    let teamVS = words(multiplesBetSlipList[0].translatedName, REGEX_VS);
    // Get the two team names (without the "vs" or "at")
    let teamNames: any =
      multiplesBetSlipList[0].translatedName !== undefined &&
      multiplesBetSlipList[0].translatedName.split(REGEX_VS);

    let betSlipHeader = (
      <div className="bet-slip__header">
        <div
          className={cx("bet-slip__header__arrow", {
            "bet-slip__header__arrow--up": this.state.isActive,
            "bet-slip__header__arrow--down": !this.state.isActive,
          })}
          onClick={this.toggleCollapsible}
        />
        <div className="bet-slip__header__teams">
          {this.renderTeamName(teamNames[0])}
          <div className="bet-slip__header__team-vs">{teamVS[0]}</div>
          {this.renderTeamName(teamNames[1])}
        </div>
        <div className="bet-slip__header__rhs" />
      </div>
    );

    let content = (
      <div className="bet-drawer__list">
        {multiplesBetSlipList.map((multiplesBetSlip, index) => {
          const marketTypes = [
            "PLAYER_TOTAL_ASSISTS_ROLLING",
            "PLAYER_TOTAL_POINTS_ROLLING",
            "PLAYER_TOTAL_BLOCKS_ROLLING",
            "PLAYER_TOTAL_STEALS_ROLLING",
            "PLAYER_TOTAL_REBOUNDS_ROLLING",
          ];
          const isMarketTypeMatch = marketTypes.includes(
            multiplesBetSlip.marketType
          );

          const playerPropsFormattedName =
            multiplesBetSlip.marketName +
            " " +
            "(" +
            multiplesBetSlip.runner.handicap +
            ")";
          // Check to see if the previous betslip message is different to current message
          // So messages are styled as a group
          const showMessage =
            multiplesBetSlipList[index - 1] === undefined ||
            multiplesBetSlipList[index - 1].message !==
              multiplesBetSlip.message;

          return (
            <div
              key={index}
              className={cx("multiples-bet-slip", {
                "multiples-bet-slip--error": multiplesBetSlip.message,
              })}
            >
              {showMessage && (
                <div className="multiples-bet-slip__message">
                  {multiplesBetSlip.message}
                </div>
              )}
              <div className="multiples-bet-slip__content">
                <div className="multiples-bet-slip__sport-icon">
                  <IconSports
                    name={multiplesBetSlip["translated-sport-name"]}
                  />
                </div>
                <div className="multiples-bet-slip__event-details">
                  <div className="multiples-bet-slip__event-details__event-name">
                    {!isMarketTypeMatch ? (
                      <>{`${teamNames[0]} ${teamVS[0]} ${teamNames[1]}`}</>
                    ) : (
                      <>
                        {BetSlipHelper.formatMarketName(
                          multiplesBetSlip.marketType,
                          playerPropsFormattedName,
                          multiplesBetSlip.marketName
                        )}
                      </>
                    )}
                  </div>
                  <div className="multiples-bet-slip__event-details__market-name">
                    <span>
                      {multiplesBetSlip.runner.name}
                      {"\u00A0"}
                    </span>
                    <span>
                      {this.renderFormattedHandicap(multiplesBetSlip)}
                    </span>
                  </div>
                  <div className="multiples-bet-slip__event-details__market-type">
                    <div className="bet-slip-content__market">
                      {multiplesBetSlip.marketType &&
                        (multiplesBetSlip.marketType === MarketTypes.TOTAL ? (
                          multiplesBetSlip.marketType ===
                          MarketTypes.CORNER_HANDICAP ? (
                            <FormattedMessage
                              tagName="span"
                              id={TranslationHelper.getTranslationIdForMarket(
                                MarketTypes.CORNER_TOTAL
                              )}
                            />
                          ) : (
                            <FormattedMessage
                              tagName="span"
                              id={TranslationHelper.getTranslationIdForMarket(
                                multiplesBetSlip.marketType,
                                multiplesBetSlip.marketPeriod,
                                multiplesBetSlip.sportType,
                                true
                              )}
                              values={{
                                homeTeam: teamNames[0],
                                awayTeam: teamNames[1],
                              }}
                            />
                          )
                        ) : (
                          <FormattedMessage
                            tagName="span"
                            id={TranslationHelper.getTranslationIdForMarket(
                              multiplesBetSlip.marketType,
                              multiplesBetSlip.marketPeriod,
                              multiplesBetSlip.sportType,
                              true
                            )}
                            values={{
                              homeTeam: teamNames[0],
                              awayTeam: teamNames[1],
                            }}
                          />
                        ))}{" "}
                      {intl.formatMessage({
                        id: TranslationHelper.getMarketNameSuffix(
                          multiplesBetSlip.marketType,
                          multiplesBetSlip.marketPeriod,
                          multiplesBetSlip.sportType
                        ),
                      })}
                      (
                      {multiplesBetSlip &&
                        (multiplesBetSlip.marketPeriod ===
                        MarketPeriods.SECOND_HALF ? (
                          <FormattedMessage
                            tagName="span"
                            id={TranslationHelper.getTranslationIdForMarket(
                              MarketPeriods.SECOND_HALF
                            )}
                          />
                        ) : (
                          <FormattedMessage
                            tagName="span"
                            id={TranslationHelper.getTranslationIdForMarket(
                              multiplesBetSlip.marketPeriod
                            )}
                          />
                        ))}
                      )
                    </div>
                  </div>
                </div>
                <div className="multiples-bet-slip__trash-icon">
                  <span
                    onClick={e => {
                      e.preventDefault();
                      this.removeMultipleBetSlip(multiplesBetSlip["runnerId"]);
                    }}
                  >
                    <IconTrash />
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );

    return (
      <div className={`multiples-bet-slip-container`}>
        <Collapsible
          header={betSlipHeader}
          content={content}
          isActive={this.state.isActive}
          status={"open"}
        />
      </div>
    );
  };

  render() {
    const { multiplesBetSlipList } = this.props;

    if (multiplesBetSlipList && multiplesBetSlipList.length > 0) {
      return <div className="bet-slip">{this.getBetSlipContent()}</div>;
    } else {
      return null;
    }
  }
}

const mapStateToProps = state => ({
  betSlipList: state.betSlipListModel.betSlipList,
});

const mapDispatchToProps = dispatch => ({
  removeMultipleLeg: runnerId => {
    dispatch.multiplesBetSlipListModel.removeMultipleLeg(runnerId);
  },
  validateMultiples: () =>
    dispatch.multiplesBetSlipListModel.validateMultiples(),
  removeBetSlip: localId => dispatch.betSlipListModel.removeBetSlip(localId),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(MultiplesBetSlip)) as any;
